import confirmDeleteView from '../app.modal/confirmDeleteModal.html';
import moment from 'moment';

export default function ($rootScope, $scope, $http, $q, $timeout, $stateParams, $state, $cookies, $uibModal, $document, contentTypes, CONFIG, ApiFactory, $location, ngToast, UtilitiesFactory) {
    'ngInject';

    moment.locale('de');

    $scope.data = {};
    $scope.context = {};
    $scope.contentTypesMenu = {};
    $scope.disabled = false;
    $scope.idParent = null;
    $scope.isProgress = true;
    $scope.navElementSelected = null;
    $scope.selectedNavId = null;
    $scope.isDropped = false;
    $scope.isDone = false;
    $rootScope.selectedNav = null;

    let version = 0;

    let paginationResultsPerPage = CONFIG.paginationResultsPerPage;
    $scope.paginationResultsPerPage = paginationResultsPerPage;

    let page = $stateParams.page || 1;
    $scope.page = parseInt(page);

    let contentType = $stateParams.contentType;
    let T = $scope.$root.T;
    let formControls = null;

    let labelSingle = contentType.name;

    let endpoint = null;
    let _navigationId = null;
    let _orderedItems = [];

    if (!$cookies.get('region')) {
        $cookies.put('region', JSON.stringify($rootScope.regions[0]));
    }

    let regionId = !!location.hash.split('/')[1] ? location.hash.split('/')[1] : !!$cookies.get('region') ? JSON.parse($cookies.get('region')).sys.id : null;

    let MobileDetect = require('mobile-detect');
    let md = new MobileDetect(window.navigator.userAgent);
    let isMobile = !!md.mobile();

    $scope.isMobile = isMobile;
    $scope.isSearch = false;
    $scope.limit = paginationResultsPerPage;
    $scope.isGetShowMore = true;
    $scope.search = $stateParams.search || null;

    let hiddenNavigationItem = ['Shop', 'Trainerbörse', 'Turnierbörse'];
    /***
     * Init
     */
    let init = () => {
        $rootScope.$on('resetNavigationBottom', (evt, args) => {
            $scope.selectedNavId = null;
        });

        $rootScope.$on('setRemoteNavigationBottom', (evt, args) => {
            //$scope.selectedNavId = args.selectedNav;
        });

        if (contentType.name === 'Article') {
            //if (!isMobile) {
            getArticles();
            //}
        } else {
            getPages();
        }
    };


    /***
     * Get all Articles (deprecated)
     */
    let getAllArticles = () => {
        endpoint = `entries?limit=1000&content_type=${contentType.sys.id}&order=-sys.updatedAt&sys.type[ne]=${(new Date()).valueOf()}`;
        //endpoint += `&fields.region.sys.id=${regionId}`;
        $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
            let _data = data.data;
            $scope.items_all = _data.items;
            if (!!$scope.search) {
                $scope.changed($scope.search);
            }

            if (isMobile) {
                $scope.isProgress = false;
                $scope.contentTypesMenu = _data.items;
                let total = $scope.contentTypesMenu.length;
                $scope.page = 1;
                $scope.pagesTotal = Math.ceil(total / paginationResultsPerPage);
                $scope.paginationRange = _.range(1, Math.round(total / paginationResultsPerPage) + 1);
            }
        });
    };

    /***
     * Get Articles
     */
    let getArticles = () => {
        let endpoint_2 = null;
        endpoint = `entries?content_type=${contentType.sys.id}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        endpoint += `&fields.region.sys.id=${regionId}`;
        if (!!$scope.search) {
            endpoint += `&fields.title[ne]=${$scope.search}&query=${$scope.search}`;
            endpoint_2 = `entries?content_type=${contentType.sys.id}&fields.title=${$scope.search}&fields.region.sys.id=${regionId}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        }
        endpoint += `&skip=${paginationResultsPerPage * (page - 1)}&limit=${paginationResultsPerPage}`;


        if (!!endpoint_2) {
            $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint_2}`).then((data) => {
                let _data = data.data;
                let regions = _data.hasOwnProperty('includes') ? _data.includes.Entry : [];
                let items = _.filter(_data.items, (item) => { return !!!item.sys.archivedAt && !!!item.sys.archivedBy });
                let resultsTotal = data.data.total;

                $scope.navigationItem = {};
                $scope.isProgress = false;
                $scope.pagesTotal = Math.ceil(resultsTotal / paginationResultsPerPage);
                $scope.paginationRange = UtilitiesFactory.paginationRange(page, CONFIG.paginationLinksOffset, $scope.pagesTotal);

                $scope.contentTypesMenu = items;

                _.forEach($scope.contentTypesMenu, (contentType) => {
                    contentType.sys.createdAt = moment(contentType.sys.createdAt).format("DD. MMMM YYYY");
                });

                _.forEach(items, (item) => {
                    _.forEach(regions, (region) => {
                        if (item.fields.hasOwnProperty('region') && region.sys.id === item.fields.region.sys.id) {
                            item.fields.region.title = region.fields.title
                        }
                    });
                });

                $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                    let _data = data.data;
                    let regions = _data.hasOwnProperty('includes') ? _data.includes.Entry : [];
                    let items = _.filter(_data.items, (item) => { return !!!item.sys.archivedAt && !!!item.sys.archivedBy });
                    let resultsTotal = data.data.total;
                    ($scope.contentTypesMenu.length > 0) ?  $scope.contentTypesMenu =  $scope.contentTypesMenu.concat(items) : $scope.contentTypesMenu = items;
                    $scope.navigationItem = {};
                    $scope.isProgress = false;
                    $scope.pagesTotal = Math.ceil(resultsTotal / paginationResultsPerPage);
                    $scope.paginationRange = UtilitiesFactory.paginationRange(page, CONFIG.paginationLinksOffset, $scope.pagesTotal);

                    _.forEach($scope.contentTypesMenu, (contentType) => {
                        contentType.sys.createdAt = moment(contentType.sys.createdAt).format("DD. MMMM YYYY");
                    });

                    _.forEach(items, (item) => {
                        _.forEach(regions, (region) => {
                            if (item.fields.hasOwnProperty('region') && region.sys.id === item.fields.region.sys.id) {
                                item.fields.region.title = region.fields.title
                            }
                        });
                    });
                });
            });
        } else {
            $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                let _data = data.data;
                let regions = _data.hasOwnProperty('includes') ? _data.includes.Entry : [];
                let items = _.filter(_data.items, (item) => { return !!!item.sys.archivedAt && !!!item.sys.archivedBy });
                let resultsTotal = data.data.total;

                // $scope.pagesTotal = resultsTotal;
                $scope.navigationItem = {};
                $scope.isProgress = false;
                $scope.pagesTotal = Math.ceil(resultsTotal / paginationResultsPerPage);
                $scope.paginationRange = UtilitiesFactory.paginationRange(page, CONFIG.paginationLinksOffset, $scope.pagesTotal);

                $scope.contentTypesMenu = items;

                _.forEach($scope.contentTypesMenu, (contentType) => {
                    contentType.sys.createdAt = moment(contentType.sys.createdAt).format("DD. MMMM YYYY");
                });

                _.forEach(items, (item) => {
                    _.forEach(regions, (region) => {
                        if (item.fields.hasOwnProperty('region') && region.sys.id === item.fields.region.sys.id) {
                            item.fields.region.title = region.fields.title
                        }
                    });
                });
            });
        }
    };

    /***
     * Get Navigation Trees
     */
    let getPages = () => {
        if (!!contentTypes) {
            let navigation = _.filter(contentTypes.items, (content) => { return content.name === 'Navigation'} );
            if (navigation.length > 0) {
                let contentTypeId = navigation[0].sys.id;
                let navigationId = null;
                endpoint = `${CONFIG.customUploadUrl}contentful/entries?content_type=${contentTypeId}&sys.type[ne]=${(new Date()).valueOf()}`;
                endpoint += `&fields.region.sys.id=${regionId}`;
                $http.get(endpoint).then((data) => {
                    if (data.data.items.length > 0) {
                        navigationId = data.data.items[0].sys.id;
                        endpoint = `entries?sys.id=${navigationId}&include=5&sys.type[ne]=${(new Date()).valueOf()}`;
                        _navigationId = data.data.items[0].sys.id;

                        $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                            let resultsTotal = data.data.total;
                            let _data = data.data;

                            $scope.pagesTotal = resultsTotal;
                            $scope.navigationItem = {};
                            $scope.isProgress = false;
                            $scope.paginationRange = _.range(1, Math.round(resultsTotal/paginationResultsPerPage) + 1);

                            let navigationItems = _data.items[0].fields.navigationItems;
                            let entries = _data.includes.Entry;
                            let errors = _data.errors;

                            _.forEach(navigationItems, (navigationItem) => {
                                navigationItem.isDropped = false;
                                let detail = _.filter(entries, (entry) => { return entry.sys.id === navigationItem.sys.id });
                                if (detail.length > 0) {
                                    navigationItem.fields = {};
                                    navigationItem.fields.title = detail.length > 0 ? detail[0].fields.title : '';
                                    navigationItem.navigationItems = detail[0].fields.navigationItems;
                                    if (!!navigationItem.navigationItems && navigationItem.navigationItems.length > 0) {
                                        let tempNav = [];

                                        _.forEach(navigationItem.navigationItems, (nav) => {
                                            _.forEach(errors, (error) => {
                                                if (error.details.id === nav.sys.id) {
                                                    let index = navigationItem.navigationItems.indexOf(nav);
                                                    tempNav.push(index);
                                                }
                                            });
                                        });

                                        _.pullAt(navigationItem.navigationItems, tempNav);

                                        _.forEach(navigationItem.navigationItems, (navigationItem) => {
                                            let detail = _.filter(entries, (entry) => { return entry.sys.id === navigationItem.sys.id });
                                            navigationItem.fields = {};
                                            navigationItem.fields.title = detail.length > 0 ? detail[0].fields.title : '';
                                        });
                                    }
                                }
                            });

                            /**
                             * Check the archived item
                             */
                            let nav = [];
                            _.forEach(navigationItems, (item) => {
                                if (item.hasOwnProperty('fields')) {
                                    if (!!!item.navigationItems || item.navigationItems.length === 0) {
                                        item.navigationItems = [];
                                        item.navigationItems.push({
                                            sys: {
                                                id: "000",
                                                linkType: "Entry",
                                                type: "Link"
                                            },
                                            fields: {
                                                title: 'No items'
                                            }
                                        })
                                    }
                                    nav.push(item);
                                }
                            });

                            $scope.contentTypesMenu = nav;
                            $scope.selectedNavId = _.first($scope.contentTypesMenu).sys.id;
                        });
                    } else {
                        $scope.isProgress = false;
                    }
                });
            }
        }
    };


    let deleteItem = (entryId) => {
        $scope.isProgress = true;
        if (!$scope.isDone) {
            $scope.isDone = true;

            $http.get(`${CONFIG.cmApiUrl}entries/${entryId}?sys.type[ne]=${(new Date()).valueOf()}`).then(data => {
                let version = data.data.sys.version;
                let deleteConfig = {
                    errorMessage: T.HTTP_DELETE_ERROR_NOTIFICATION + labelSingle,
                    headers: {
                        'X-Contentful-Version': version
                    }
                };
    
                $http.delete(`${CONFIG.cmApiUrl}entries/${entryId}/published?sys.type[ne]=${(new Date()).valueOf()}`, deleteConfig).then(() => {
                    let putConfig = {
                        successMessage: labelSingle + T.HTTP_DELETE_SUCCESS_NOTIFICATION,
                        errorMessage: T.HTTP_DELETE_ERROR_NOTIFICATION + labelSingle,
                        headers: {
                            'X-Contentful-Version': version
                        }
                    };
    
                    $http.put(`${CONFIG.cmApiUrl}entries/${entryId}/archived?sys.type[ne]=${(new Date()).valueOf()}`, null, putConfig).then(() => {
                        $state.go('^.list');
                        $scope.isDone = false;
                        init();
                    });
                }, (error) => {
                    $scope.isProgress = false;
                    $scope.isDone = false;
                    $rootScope.raven.captureException(error);
                    $rootScope.raven.showReportDialog();
                });
            });
        }
    };

    /***
     * Create a data for POST call
     * @returns {{}}
     */
    let dataToPost = (idNavigationItem = null) => {
        let result = {};
        let _region = JSON.parse($cookies.get('region'));
        formControls.forEach((control) => {
            let id = control.id;

            result[id] = null;

            result['title'] = 'Unbenannt';

            // NavigationItem
            if (control.type === 'Link' && control.linkType === 'Entry') {
                result[id] = {
                    sys: {
                        type: 'Link',
                        linkType: 'Entry',
                        id: idNavigationItem
                    }
                };
            }

            result['region'] =  {
                sys: {
                    'id': _region.sys.id,
                    'type': 'Link',
                    'linkType': 'Entry'
                }
            };
        });

        return result;
    };

    /***
     * Create a data for POST call on Navigation
     * @returns {{}}
     */
    let dataToPostForNavigation = (navigationItems, idNavigationItem, isEdit = false) => {
        let results = {};

        formControls.forEach((control) => {
            let id = control.id;

            if (isEdit) {
                if (control.type === 'Array' && control.items.type === 'Link' && control.items.linkType === 'Entry') {
                    results = _.map(navigationItems, (nav) => {
                        return {
                            sys: nav.sys
                        }
                    });
                }
            } else {
                // Navigation Item
                if (control.type === 'Array' && control.items.type === 'Link' && control.items.linkType === 'Entry') {
                    if (!navigationItems.hasOwnProperty('navigationItems')) {
                        navigationItems.navigationItems = {en: []};
                    }
                    navigationItems[id].en.push({
                        sys: {
                            type: 'Link',
                            linkType: 'Entry',
                            id: idNavigationItem
                        }
                    });
                    results = navigationItems;
                }
            }
        });

        return results;
    };


    /***
     * Post Action
     * @param isPage
     * @param config
     * @param idNavigationItem
     */
    let postAction = (isPage = false, config, idNavigationItem) => {
        $q.all(dataToPost(idNavigationItem)).then((data) => {
            let dataToPost = _.mapValues(data, (value) => {
                return {
                    en: value
                };
            });


            return $http.post(`${CONFIG.cmApiUrl}entries?sys.type[ne]=${(new Date()).valueOf()}`, {fields: dataToPost}, config).then( (data) => {
                let sys = data.data.sys;
                let idNewNavigationItem = sys.id;

                let config = {
                    successMessage: `Page${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
                    errorMessage: `${T.HTTP_POST_ERROR_NOTIFICATION}Page`,
                    headers: {
                        'X-Contentful-Version': sys.version
                    }
                };

                return $http.put(`${CONFIG.cmApiUrl}entries/${sys.id}/published?sys.type[ne]=${(new Date()).valueOf()}`, null, config).then(() => {
                    if (!isPage) {
                        /**
                         * Add new Navigation items to its parent then add new page
                         */
                        return $http.get(CONFIG.cmApiUrl + 'entries/' + $scope.selectedNavId).then( (data) => {
                            let fields = data.data.fields;
                            let version = data.data.sys.version;

                            let config = {
                                successMessage: 'Navigation' + T.HTTP_POST_SUCCESS_NOTIFICATION,
                                errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + 'Navigation',
                                headers: {
                                    'X-Contentful-Version': version
                                }
                            };

                            return $http.put(`${CONFIG.cmApiUrl}entries/${$scope.selectedNavId}?sys.type[ne]=${(new Date()).valueOf()}`, {fields: dataToPostForNavigation(fields, idNewNavigationItem)}, config).then( (data) => {
                                let sys = data.data.sys;

                                let config = {
                                    successMessage: 'Navigation' + T.HTTP_POST_SUCCESS_NOTIFICATION,
                                    errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + 'Navigation',
                                    headers: {
                                        'X-Contentful-Version': sys.version
                                    }
                                };
                                return $http.put(CONFIG.cmApiUrl + 'entries/' + sys.id + '/published', null, config).then(() => {
                                    $scope.isDone = false;
                                    $scope.addNewPage(idNewNavigationItem);
                                });
                            });

                        });
                    } else {
                        //$state.reload();
                        init();
                    }
                }, (e) => {
                        $rootScope.raven.captureException(e);
                        $rootScope.raven.showReportDialog();
                    return $http.delete(`${CONFIG.cmApiUrl}entries/${sys.id}?sys.type[ne]=${(new Date()).valueOf()}`);
                });
            });
        }).finally(() => {
            $scope.requestInProgress = false;
        });
    };


    /***
     * Find a Navigation Parent through a its child
     * @param parent
     * @param child
     */
    let findNavigationParent = (parent, child) => {
        _.map(parent, (navigationItem) => {
            if (!!navigationItem.navigationItems && navigationItem.navigationItems.length > 0) {
                _.map(navigationItem.navigationItems, (navItm) => {
                    if (navItm.sys.id === child.sys.id) {
                        return navigationItem
                    }
                });
            }
        });
    };


    let buildUpdateRequest = (navigationId, navigationItems) => {
        $scope.isProgress = true;
        let config = {
            errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelSingle
        };

        return $http.get(`${CONFIG.cmApiUrl}entries/${navigationId}?sys.type[ne]=${(new Date()).valueOf()}`, config).then(data => {
            let fields = data.data.fields;
            let sys = data.data.sys;
            let _region = JSON.parse($cookies.get('region'));

            let navItms = _.map(navigationItems, (nav) => {
                return {
                    sys: nav.sys
                }
            });

            let region = {
                en: {
                    sys: {
                        'id': _region.sys.id,
                        'type': 'Link',
                        'linkType': 'Entry'
                    }
                }
            };

            if (!fields.hasOwnProperty('navigationItems')) {
                fields.navigationItems = {};
            }
            fields.navigationItems.en = navItms;
            fields.region = region;


            let config = {
                errorMessage: T.HTTP_PUT_ERROR_NOTIFICATION + labelSingle,
                headers: {
                    'X-Contentful-Version': sys.version
                }
            };

            return $http.put(`${CONFIG.cmApiUrl}entries/${navigationId}?sys.type[ne]=${(new Date()).valueOf()}`, {fields: fields}, config).then(data => {
                sys = data.data.sys;
                let config = {
                    successMessage: labelSingle + T.HTTP_PUT_SUCCESS_NOTIFICATION,
                    errorMessage: T.HTTP_PUT_ERROR_NOTIFICATION + labelSingle,
                    headers: {
                        'X-Contentful-Version': sys.version
                    }
                };

                return $http.put(`${CONFIG.cmApiUrl}entries/${navigationId}/published`, null, config);
            });
        });
    };

    /***
     *
     * @param items
     */
    let updateNavigation = (items) => {
        if (!$scope.isDone) {
            $scope.isDone = true;
            buildUpdateRequest(_navigationId, items).then( () => {
                this.isProgress = false;
                $scope.isDone = false;
                getPages();
            }, (e) => {
                $rootScope.raven.captureException(e);
                $rootScope.raven.showReportDialog();
                $scope.isDone = false;
            })
        }
    
    };


    /***
     * Remove a navigation item from Navigation object
     * @param sourceRemove
     */
    let removeNavigationItemFromNavigation = (sourceRemove) => {
        endpoint = `${CONFIG.customUploadUrl}contentful/entries?content_type=navigation&sys.type[ne]=${(new Date()).valueOf()}`;
        endpoint += `&fields.region.sys.id=${regionId}`;
        return $http.get(endpoint).then((data) => {
            return $http.get(CONFIG.cmApiUrl + 'entries/' + data.data.items[0].sys.id).then( (data) => {
                let version = data.data.sys.version;
                let id = data.data.sys.id;
                let fields = data.data.fields;
                fields.navigationItems.en = _.filter(fields.navigationItems.en, (item) => { return item.sys.id !== sourceRemove.sys.id; });

                let config = {
                    successMessage: 'Navigation' + T.HTTP_POST_SUCCESS_NOTIFICATION,
                    errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + 'Navigation',
                    headers: {
                        'X-Contentful-Version': version
                    }
                };

                return $http.put(`${CONFIG.cmApiUrl}entries/${id}?sys.type[ne]=${(new Date()).valueOf()}`, { fields:  fields }, config).then( (data) => {
                    let sys = data.data.sys;

                    let config = {
                        successMessage: 'Navigation' + T.HTTP_POST_SUCCESS_NOTIFICATION,
                        errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + 'Navigation',
                        headers: {
                            'X-Contentful-Version': sys.version
                        }
                    };

                    return $http.put(CONFIG.cmApiUrl + 'entries/' + sys.id + '/published', null, config)
                });
            });
        });
    };

    /***
     * Remove children from Navigation Item
     * @param navigationItem
     * @param sourceRemove
     */
    let removeChildrenFromNavigationItem = (navigationItem, sourceRemove) => {
        return $http.get(CONFIG.cmApiUrl + 'entries/' + navigationItem.sys.id).then( (data) => {
            let fields = data.data.fields;
            let version = data.data.sys.version;
            let id = data.data.sys.id;
            fields.navigationItems.en = _.filter(fields.navigationItems.en, (item) => { return item.sys.id !== sourceRemove.sys.id; });

            let config = {
                successMessage: 'Navigation' + T.HTTP_POST_SUCCESS_NOTIFICATION,
                errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + 'Navigation',
                headers: {
                    'X-Contentful-Version': version
                }
            };

            return $http.put(`${CONFIG.cmApiUrl}entries/${id}?sys.type[ne]=${(new Date()).valueOf()}`, { fields:  fields }, config).then( (data) => {
                let sys = data.data.sys;

                let config = {
                    successMessage: 'Navigation' + T.HTTP_POST_SUCCESS_NOTIFICATION,
                    errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + 'Navigation',
                    headers: {
                        'X-Contentful-Version': sys.version
                    }
                };

                return $http.put(CONFIG.cmApiUrl + 'entries/' + sys.id + '/published', null, config)
            });
        });
    };

    /****
     *
     * @param navigationId
     * @param orderedItems
     * @param sourceNavigationId
     * @param sourceNavigationItems
     * @param sourceRemove
     */
    let update = (navigationId, orderedItems, sourceNavigationId, sourceNavigationItems, sourceRemove) => {
        sourceNavigationItems = _.filter(sourceNavigationItems, (source) => {
            return source.sys.id !== sourceRemove.sys.id;
        });

        orderedItems = _.filter(orderedItems, (source) => {
            return source.sys.id !== '000';
        });

        orderedItems.push(sourceRemove);

        let _contentType = _.filter(contentTypes.items, (type) => { return type.name ===  "Navigation" });
        formControls = _contentType[0].fields;

        // Update new node
        let destinationPublishPromise = buildUpdateRequest(navigationId, orderedItems);

        destinationPublishPromise.then(() => {
            if (sourceNavigationId !== sourceRemove.sys.id) {
                buildUpdateRequest(sourceNavigationId, sourceNavigationItems).then(() => {
                    $scope.isProgress = false;
                    getPages();
                });
            } else {
                removeNavigationItemFromNavigation(sourceRemove).then(() => {
                    $scope.isProgress = false;
                    getPages();
                }, (e) => {
                    $rootScope.raven.captureException(e);
                    $rootScope.raven.showReportDialog();
                });
            }
        });
    };

    $scope.saveContentType = () => {
        version = $scope.context.sys.version;

        let config = {
            headers: {
                'X-Contentful-Version': version
            }
        };

        let dataToPost = {
            "name": $scope.context.name,
            "description": $scope.context.description,
            "displayField": $scope.context.displayField,
            "fields": $scope.context.fields
        };

        let id = $scope.context.sys.id;

        $http.put(`${CONFIG.cmApiUrl}content_types/${id}?sys.type[ne]=${(new Date()).valueOf()}`, dataToPost, config ).then((response) => {
            $rootScope.visible = true;
            $scope.disabled = true;
            version = response.data.sys.version;
            $scope.context = {};

            $timeout(() => {
                ApiFactory.getContentTypes(response.data.sys.version).then( (response) => {
                    $scope.contentTypesMenu = response.items;
                    $scope.disabled = false;
                    $rootScope.visible = false;
                }, (error) => {
                    console.error('Updating SideNav failed', error);
                });
            }, 4000);
        });
    };

    $scope.checkName = (data) => {
        $scope.context = data;
    };

    /***
     * Add new navigation Item
     * @constructor
     */
    $scope.AddNewNAvigationItem = () => {
        if (!$scope.isDone) {
            $scope.isDone = true;

            let _contentType = _.filter(contentTypes.items, (type) => { return type.name ===  "Navigation Item" });
            formControls = _contentType[0].fields;
    
            let config = {
                errorMessage: T.HTTP_POST_ERROR_NOTIFICATION,
                headers: {
                    'X-Contentful-Content-Type': _contentType[0].sys.id
                }
            };
    
            $scope.isProgress = true;
            postAction(false, config);
        }
    };

    /***
     * Add new page and linked with navigation item created before
     */
    $scope.addNewPage = (idNavigationItem) => {
        let _contentType = _.filter(contentTypes.items, (type) => { return type.name === 'Page' });
        formControls = _contentType[0].fields;  // Page


        let config = {
            errorMessage: T.HTTP_POST_ERROR_NOTIFICATION,
            headers: {
                'X-Contentful-Content-Type': _contentType[0].sys.id
            }
        };

        $scope.isProgress = true;
        postAction(true, config, idNavigationItem);
    };


    /***
     * Store the navigation Item id
     * @param nav
     */
    $scope.signSelectedNavItm = (parent, child) => {
        if (!hiddenNavigationItem.includes(contentType.fields.title)) {
            $scope.selectedNavId = parent.sys.id;
            $scope.selectedNavChildId = child.sys.id;
        }
    };

    /***
     * Tree Options
     * @type {{dropped: ((p1?:*))}}
     */
    $scope.treeOptions = {
        accept: (sourceNodeScope, destNodesScope, destIndex) => {
            return true;
        },
        dropped: (event) => {
            $scope.isDropped = true;
            let destNavigation = null;
            let sourceNavigation = null;
            let sourceRemove = event.source.nodeScope.$modelValue;
            let sources = event.source.nodesScope.$modelValue;
            let orders = event.dest.nodesScope.$modelValue;
            let arr = _.filter(orders, (source) => { return source.hasOwnProperty('navigationItems') });
            let flag = false;
            if (arr.length > 0) { // Navigation
                _.map(angular.copy(event.dest.nodesScope.$modelValue), (navigationItem) => {
                    if (!!navigationItem.navigationItems && navigationItem.navigationItems.length > 0) {
                        _.map(navigationItem.navigationItems, (item) => {
                            if (item.sys.id === sourceRemove.sys.id) {
                                $scope.isProgress = true;
                                removeChildrenFromNavigationItem(navigationItem, sourceRemove).then((res) => {
                                    updateNavigation(orders);
                                }, (e) => {
                                    $rootScope.raven.captureException(e);
                                    $rootScope.raven.showReportDialog();
                                });
                            } else {
                                flag = true;
                            }
                        });
                    }
                });
                if (flag) updateNavigation(orders);
            } else { // Navigation Items
                _.map($scope.contentTypesMenu, (navigationItem) => {
                    navigationItem.isDropped = false;
                    if (!!navigationItem.navigationItems && navigationItem.navigationItems.length > 0) {
                        _.map(orders, (order) => {
                            if (navigationItem.navigationItems[0].sys.id === order.sys.id) {
                                destNavigation = navigationItem;
                                _navigationId = navigationItem.sys.id;
                                _orderedItems = orders;
                            }
                        });
                    }
                });

                /*** Drop first level to other first level **/
                if (!!! sourceNavigation) {
                    sourceNavigation = sourceRemove;
                }
                const checkInternalChanges = _.filter(destNavigation.navigationItems, (nav) => { return sourceRemove.sys.id === nav.sys.id });
                
                if (checkInternalChanges.length === 0) {
                    if (!!destNavigation && !!sourceNavigation && !!sourceRemove) {
                        destNavigation.isDropped = false;
                        destNavigation.navigationItems = _.filter(destNavigation.navigationItems, (navigation) => { return navigation.sys.id !== '000' });

                        update(destNavigation.sys.id, angular.copy(event.dest.nodesScope.$modelValue), sourceNavigation.sys.id, angular.copy(event.source.nodesScope.$modelValue), angular.copy(sourceRemove));
                        ngToast.create({
                            className: 'toast-success',
                            content: `${T.NAVIGATION} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                            timeout: 4000
                        });
                    }
                } else {
                    destNavigation.isDropped = true;
                }
            }

        }
    };


    /***
     * Publish the new version of navigation
     */
    $scope.publish = () => {
        if (!$scope.isDone) {
            $scope.isDone = true;
            $scope.contentTypesMenu.map( (contentType) => {
                contentType.isDropped = false;
            });
    
            buildUpdateRequest(_navigationId, _orderedItems).then( () => {
                $scope.isProgress = false;
                $scope.isDone = false;
                getPages();
                ngToast.create({
                    className: 'toast-success',
                    content: `${T.NAVIGATION} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                    timeout: 4000
                });
            });
        }
    };


    /***
     * Remove the drag&drop events
     */
    $scope.cancel = () => {
        $scope.isProgress = true;
        init();
    };

    /***
     *
     * Archive selected item
     * @param entryId
     */
    $scope.remove = (entryId) => {
        if (!$scope.isDone) {
            $scope.isDone = true;

            let modalInstance = $uibModal.open({
                template: confirmDeleteView
            });
    
            modalInstance.result.then(() => {
                $scope.isDone = false;
                deleteItem(entryId);
            }, () => {
                $scope.isDone = false;
            });
    
            $scope.$root.modal = modalInstance;
        }
    };

    // get actice article ID
    const curLoaction = $location.$$url;
    $scope.activeId = curLoaction.replace('/article/edit/', '');

    /***
     * Add new article
     */
    $scope.addArticle = () => {
        $state.go('^.add');
    };

    /***
     * Remove Items
     * @param id
     */
    $scope.removeItem = (id) => {
        $scope.remove(id);
    };


    /***
     * Redirect to the page
     * @param idNavigation
     * @param idParent
     * @param navTitle
     */
    $scope.goDetail = (idNavigation, idParent, navTitle) => {
        if (!hiddenNavigationItem.includes(navTitle)) {
            $document.scrollTop(0, 1000);
            //if (!!!$rootScope._preventNavigation) {
            $rootScope.selectedNav = idNavigation;
            $state.go('^.list', {
                idNavigation: idNavigation,
                idParent: idParent,
                navTitle: navTitle
            });
            //}
        }

    };


    /***
     * Searchbar callback
     * @param word
     * @param keyCode
     */
    $scope.changed = (word, keyCode = null) => {
        $scope.search = word;
        let getData = (data) => {
            $scope.contentTypesMenu = data.data.items;
            $scope.pagesTotal = Math.ceil(data.data.total / paginationResultsPerPage);
            //$scope.paginationRange = _.range(1, Math.round($scope.contentTypesMenu.length / paginationResultsPerPage) + 1);
            $scope.paginationRange = UtilitiesFactory.paginationRange(page, CONFIG.paginationLinksOffset, $scope.pagesTotal);
        };

        let endpoint_final = `&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        endpoint_final += `&fields.region.sys.id=${regionId}`;


        if (keyCode === 13 || word === '') {
            $state.go('^.list', { page: 1, search: word });
            /*$scope.isProgressData = true;
            $http.get(`${CONFIG.cmApiUrl}entries?content_type=article&query=${word}${endpoint_final}`).then((data) => {
                data.data.items = _.filter(data.data.items, (item) => { return !!!item.sys.archivedAt && !!!item.sys.archivedBy });
                data.data.items.map((item) => {
                    item.fields.title = item.fields.hasOwnProperty('title') ? item.fields.title.en : '';
                    item.fields.authorName = item.fields.hasOwnProperty('authorName') ? item.fields.authorName.en : '';
                    $scope.isProgressData = false;
                });
                getData(data);
            });*/
        }
    };


    /***
     * Show more callback
     */
    $scope.getShowMore = () => {
        if ($scope.contentTypesMenu.length > $scope.limit) {
            $scope.limit += paginationResultsPerPage;
        } else {
            $scope.isGetShowMore = false;
        }
    };

    init();
}



// WEBPACK FOOTER //
// ./src/app/views/app.sidenav/AppSideNavCtrl.js